import EmailEdit from './EmailEdit';

export default EmailEdit;
